import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import CertificateService from "../../services/CertificateService";

import {
  listSuccess,
  listFail,
  createFail,
  createSuccess,
  deleteSuccess,
  deleteFail,
} from "../slices/certificateSlice";

function* list(data) {
  try {
    const ajax = yield call(CertificateService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(CertificateService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteCertificate(data) {
  try {
    const ajax = yield call(CertificateService.delete, data.payload);
    if (ajax.status === 200) {
      yield put(deleteSuccess(ajax.data));
    } else {
      yield put(
        deleteFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* certificateService() {
  yield all([
    takeLatest("certificates/listRequest", list),
    takeLatest("certificates/createRequest", create),
    takeLatest("certificates/deleteRequest", deleteCertificate),
  ]);
}
